var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9868 11.002L12.9988 2.01399C12.4476 1.46279 11.5532 1.46279 11.0012 2.01399L2.01399 11.002C1.46279 11.5532 1.46279 12.4476 2.01399 12.9996L11.002 21.9876C11.5532 22.5388 12.4476 22.5388 12.9996 21.9876L21.9876 12.9996C22.538 12.4476 22.538 11.5532 21.9868 11.002Z",
    fill: "#707579"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.056 6.40039C12.588 6.40039 13.0159 6.83791 13.0041 7.36975L12.8836 12.791C12.8736 13.2409 12.506 13.6004 12.056 13.6004C11.606 13.6004 11.2384 13.2409 11.2284 12.791L11.1079 7.36975C11.0961 6.83791 11.524 6.40039 12.056 6.40039Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0584 17.7516C11.396 17.7516 11 17.3988 11 16.806C11 16.202 11.3952 15.8492 12.0584 15.8492C12.716 15.8492 13.1112 16.202 13.1112 16.806C13.1112 17.3988 12.716 17.7516 12.0584 17.7516Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.ee61fdc5e5f931754a3e0142c0a13108.svg";
export { ForwardRef as ReactComponent };